export const SELECT_CONTENT = "select_content";
export const VIEW_CONTENT = "view_content";
export const VIRTUAL_PAGEVIEW = "virtualPageview";
